import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-1">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-600">
              最新影视动态、幕后故事、深度影评
            </p>
          </div>
          <Link
            to="/about"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            更多资讯 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - ${article.category}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-secondary-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-foreground-500">{article.views}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}